<template>
  <summary-count title="Activities Due" :is-loading="isLoading" :count="activities" :change-count="null" :tooltip="tooltipText" />
</template>

<script>
import { mapGetters } from "vuex";
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";
import moment from "moment";

export default {
  name: "Activities",
  components: {
    SummaryCount,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activities: 0,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("role", ["isLocationFiltered"]),
    startOfWeek() {
      return moment()
        .startOf("week")
        .toDate();
    },
    endOfWeek() {
      return moment()
        .endOf("week")
        .toDate();
    },
    tooltipText() {
      return `This number represents what activities are due both today and before today's date.`;
    },
  },
  created() {
    this.loadActivities();
  },
  methods: {
    loadActivities() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/dashboard/activities`;

      this.$axios
        .get(url, {
          params: {
            startOfWeek: this.startOfWeek,
            endOfWeek: this.endOfWeek,
          },
        })
        .then((res) => {
          this.activities = res.data.activities;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    gotoLink() {
      if (this.isLocationFiltered) this.$router.push(`/businesses/${this.businessId}/location-todo/due-today`);
      else this.$router.push(`/businesses/${this.businessId}/business-todo/unassigned`);
    },
  },
};
</script>
